// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_COMPACTING_DC_REQUEST = 'FETCH_COMPACTING_DC_REQUEST';
export const FETCH_COMPACTING_DC_SUCCESS = 'FETCH_COMPACTING_DC_SUCCESS';
export const FETCH_COMPACTING_DC_FAILURE = 'FETCH_COMPACTING_DC_FAILURE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_COMPACTING_DC_STYLE_REQUEST = 'FETCH_COMPACTING_DC_STYLE_REQUEST';
export const FETCH_COMPACTING_DC_STYLE_SUCCESS = 'FETCH_COMPACTING_DC_STYLE_SUCCESS';
export const FETCH_COMPACTING_DC_STYLE_FAILURE = 'FETCH_COMPACTING_DC_STYLE_FAILURE';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_COMPACTING_DC_REQUEST = 'CREATE_COMPACTING_DC_REQUEST';
export const CREATE_COMPACTING_DC_SUCCESS = 'CREATE_COMPACTING_DC_SUCCESS';
export const CREATE_COMPACTING_DC_FAILURE = 'CREATE_COMPACTING_DC_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_COMPACTING_DC = 'CREATE_USER_FORM_COMPACTING_DC';

// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_COMPACTING_DC_REQUEST = 'UPDATE_COMPACTING_DC_REQUEST';
export const UPDATE_COMPACTING_DC_SUCCESS = 'UPDATE_COMPACTING_DC_SUCCESS';
export const UPDATE_COMPACTING_DC_FAILURE = 'UPDATE_COMPACTING_DC_FAILURE';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_COMPACTING_DC_REQUEST = 'FETCH_SINGLE_COMPACTING_DC_REQUEST';
export const FETCH_SINGLE_COMPACTING_DC_SUCCESS = 'FETCH_SINGLE_COMPACTING_DC_SUCCESS';
export const FETCH_SINGLE_COMPACTING_DC_FAILURE = 'FETCH_SINGLE_COMPACTING_DC_FAILURE';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_COMPACTING_DC_REQUEST = 'DELETE_COMPACTING_DC_REQUEST';
export const DELETE_COMPACTING_DC_SUCCESS = 'DELETE_COMPACTING_DC_SUCCESS';
export const DELETE_COMPACTING_DC_FAILURE = 'DELETE_COMPACTING_DC_FAILURE';

// USERFORM RESET

export const COMPACTING_DC_USERFORM_RESET = 'COMPACTING_DC_USERFORM_RESET';

// navigate to unit component
export const NAVIGATE_COMPACTING_DC_DETAILS = 'NAVIGATE_COMPACTING_DC_DETAILS';
// navigate to company component
export const NAVIGATE_COMPACTING_DC = 'NAVIGATE_COMPACTING_DC';
export const COMPACTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB = 'COMPACTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB';
export const COMPACTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE = 'COMPACTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_COMPACTING_DC_INVOICE_REQUEST = 'FETCH_COMPACTING_DC_INVOICE_REQUEST';
export const FETCH_COMPACTING_DC_INVOICE_SUCCESS = 'FETCH_COMPACTING_DC_INVOICE_SUCCESS';
export const FETCH_COMPACTING_DC_INVOICE_FAILURE = 'FETCH_COMPACTING_DC_INVOICE_FAILURE';

// CALL OFF //
export const DELETE_COMPACTING_DIV_REQUEST_CALL_OFF = 'DELETE_COMPACTING_DIV_REQUEST_CALL_OFF';
export const DELETE_COMPACTING_DIV_SUCCESS_CALL_OFF = 'DELETE_COMPACTING_DIV_SUCCESS_CALL_OFF';
export const DELETE_COMPACTING_DIV_FAILURE_CALL_OFF = 'DELETE_COMPACTING_DIV_FAILURE_CALL_OFF';

export const RESET_COMPACTING_DC_INVOICE_V2 = 'RESET_COMPACTING_DC_INVOICE_V2';

export const FETCH_COMPACTING_DC_DETAILS_RATE_FROM_STYLE_REQUEST = 'FETCH_COMPACTING_DC_DETAILS_RATE_FROM_STYLE_REQUEST';
export const FETCH_COMPACTING_DC_DETAILS_RATE_FROM_STYLE_SUCCESS = 'FETCH_COMPACTING_DC_DETAILS_RATE_FROM_STYLE_SUCCESS';

export const FETCH_COMPACTING_DC_DETAILS_RATE_FROM_STYLE_FAILURE = 'FETCH_COMPACTING_DC_DETAILS_RATE_FROM_STYLE_FAILURE';

export const CHECK_ALL_UPDATE_REQUEST_COMPACTING = 'CHECK_ALL_UPDATE_REQUEST_COMPACTING';
export const CHECK_ALL_UPDATE_SUCCESS_COMPACTING = 'CHECK_ALL_UPDATE_SUCCESS_COMPACTING';
export const CHECK_ALL_UPDATE_FALIURE_COMPACTING = 'CHECK_ALL_UPDATE_FALIURE_COMPACTING';

export const CLOSE_BTN_POST_REQUEST_COMPACTING = 'CLOSE_BTN_POST_REQUEST_COMPACTING';
export const CLOSE_BTN_POST_SUCCESS_COMPACTING = 'CLOSE_BTN_POST_SUCCESS_COMPACTING';
export const CLOSE_BTN_POST_FALIURE_COMPACTING = 'CLOSE_BTN_POST_FALIURE_COMPACTING';


export const COMPACTING_DC_DIA_REQUEST = 'COMPACTING_DC_DIA_REQUEST';
export const COMPACTING_DC_DIA_SUCCESS = 'COMPACTING_DC_DIA_SUCCESS';
export const COMPACTING_DC_DIA_FALIURE = 'COMPACTING_DC_DIA_FALIURE';

export const FETCH_COMPACTING_DIVISION_DYEING_DCNO_ID_REQUEST = 'FETCH_COMPACTING_DIVISION_DYEING_DCNO_ID_REQUEST';
export const FETCH_COMPACTING_DIVISION_DYEING_DCNO_ID_SUCCESS = 'FETCH_COMPACTING_DIVISION_DYEING_DCNO_ID_SUCCESS';
export const FETCH_COMPACTING_DIVISION_DYEING_DCNO_ID_FAILURE = 'FETCH_COMPACTING_DIVISION_DYEING_DCNO_ID_FAILURE';

export const CANCEL_COMPACTING_DIV_REQUEST = 'CANCEL_COMPACTING_DIV_REQUEST';
export const CANCEL_COMPACTING_DIV_SUCCESS = 'CANCEL_COMPACTING_DIV_SUCCESS';
export const CANCEL_COMPACTING_DIV_FAILURE = 'CANCEL_COMPACTING_DIV_FAILURE';

export const HEADER_SEARCH_CALL_ONLOAD = 'HEADER_SEARCH_CALL_ONLOAD';